import Footer from '@components/layout/footer/Footer';
import HeaderWrapper from '@components/layout/header/headerWrapper';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ScrollToTop from 'react-scroll-to-top';

import { Outlet, useLoaderData } from 'react-router-dom';

import type { CurriculumParams } from '@store/curriculum/CurriculumParams';
import './curriculum.scss';
import type { RootState } from '@store/storeSetup';
import { useSelector } from 'react-redux';
import LeerplanHeader from './section/header/LeerplanHeader';
import CurriculumTabs from './tabs/CurriculumTabs';

const Curriculum: React.FC = () => {
  const data = useLoaderData() as { params?: CurriculumParams };
  const isSelectionMode = useSelector((state: RootState) => state.curriculum.selectionMode);

  return (
    <>
      {!isSelectionMode && (
        <div id="fixed-header" className="fixed-header">
          <HeaderWrapper />
        </div>
      )}

      {'preview' in data && data.preview && <div className="preview-example">VOORBEELD</div>}

      <LeerplanHeader />

      {!isSelectionMode && <CurriculumTabs />}

      <div className="curriculum-container">
        <Outlet context={{ params: data.params }} />
      </div>

      <Footer />
      <ScrollToTop smooth component={<ArrowUpwardIcon />} />
    </>
  );
};

export default Curriculum;
